var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, CircularProgress } from "@mui/material";
var Loader = function (_a) {
    var open = _a.open, sx = _a.sx, zIndex = _a.zIndex;
    return (_jsx(Backdrop, __assign({ sx: __assign(__assign({}, sx), { zIndex: zIndex }), open: open }, { children: _jsx(CircularProgress, { color: "inherit" }) })));
};
export default Loader;
